import type { WalletSession as WalletSessionType } from "@whop/embedded-components-vanilla-js/types";

import { useRef } from "react";

export function useWalletSessionRef() {
	const ref = useRef<{
		walletSession: WalletSessionType | null;
	}>(null);
	return ref;
}
